import { ComponentType } from "react";
import "./serviceGraphics.css";

/*
 * Mock product UIs that illustrate each service on the Services page.
 * Pure HTML/CSS/SVG (no images): they scale with their column through
 * container query units (see serviceGraphics.css), use role colour tokens
 * only, and are decorative (aria-hidden). Example data only — no claims.
 */

/** 30 days of uptime bars; `hit` marks one day with a resolved incident. */
const Uptime = ({ hit }: { hit?: number }) => (
  <div className="gfx-uptime">
    {Array.from({ length: 30 }, (_, i) => (
      <i key={i} className={i === hit ? "hit" : undefined} />
    ))}
  </div>
);

const WebGraphic = () => (
  <div className="is-gfx gfx--web" aria-hidden="true">
    <div className="gfx-win">
      <div className="gfx-bar">
        <div className="gfx-lights"><i></i><i></i><i></i></div>
        <div className="gfx-url"><svg viewBox="0 0 8 9"><rect x="0.5" y="4" width="7" height="4.5" rx="1" fill="currentColor"></rect><path d="M2 4 V2.6 a2 2 0 0 1 4 0 V4" fill="none" stroke="currentColor" strokeWidth="1.1"></path></svg>yourbrand.ca/shop/everyday-tote</div>
      </div>
      <div className="gfx-shop">
        <div className="gfx-shop__nav">
          <span className="gfx-shop__logo">yourbrand</span>
          <span>Shop</span><span>Journal</span><span>About</span>
          <span className="gfx-shop__cart"><svg viewBox="0 0 18 18"><path d="M2 3 H4.5 L6.5 12 H14 L15.5 6 H5.4" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"></path><circle cx="7.5" cy="15" r="1.2" fill="currentColor"></circle><circle cx="13" cy="15" r="1.2" fill="currentColor"></circle></svg><span className="gfx-shop__badge"><span>1</span><span>2</span></span></span>
        </div>
        <div className="gfx-shop__main">
          <div className="gfx-shop__photo">
            <svg viewBox="0 0 120 120"><path d="M42 40 C42 22 78 22 78 40" fill="none" stroke="var(--is-accent)" strokeWidth="5" strokeLinecap="round"></path><path d="M24 40 H96 L90 104 H30 Z" fill="var(--is-primary)"></path><path d="M24 40 H96 L95 50 H25 Z" fill="var(--is-track)"></path><circle cx="60" cy="74" r="6" fill="none" stroke="var(--is-accent)" strokeWidth="3"></circle></svg>
            <div className="gfx-shop__thumbs"><i></i><i></i><i></i><i></i></div>
          </div>
          <div className="gfx-shop__info">
            <span className="gfx-shop__eyebrow">NEW · BAGS</span>
            <span className="gfx-shop__name">Everyday Tote</span>
            <span className="gfx-shop__price">$48.00 CAD</span>
            <span className="gfx-shop__label">Colour — Navy</span>
            <div className="gfx-shop__swatches"><i></i><i></i><i></i></div>
            <span className="gfx-shop__label">Quantity</span>
            <div className="gfx-shop__qty"><span>−</span><span>1</span><span>+</span></div>
            <div className="gfx-shop__btn">Add to cart</div>
            <span className="gfx-shop__note">Free shipping in Canada over $75</span>
          </div>
        </div>
        <div className="gfx-shop__more">
          <div><i></i><span><b>Weekend Duffel</b>$96.00</span></div>
          <div><i></i><span><b>Card Wallet</b>$28.00</span></div>
          <div><i></i><span><b>Laptop Sleeve</b>$42.00</span></div>
        </div>
      </div>
    </div>
    <div className="gfx-chip gfx-toast">
      <span className="gfx-toast__thumb"><svg viewBox="0 0 120 120"><path d="M42 40 C42 22 78 22 78 40" fill="none" stroke="var(--is-accent)" strokeWidth="7" strokeLinecap="round"></path><path d="M24 40 H96 L90 104 H30 Z" fill="var(--is-primary)"></path></svg></span>
      <span><b>Added to cart</b><span>Everyday Tote · Navy</span></span>
      <span className="gfx-check"><svg viewBox="0 0 16 16"><path d="M3.5 8.5 L6.5 11.5 L12.5 4.5" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round"></path></svg></span>
    </div>
    <svg className="gfx-cursor" viewBox="0 0 18 22"><path d="M2 1 L2 18 L6.5 13.8 L9.6 20.5 L12.4 19.2 L9.4 12.6 L15.5 12.4 Z" fill="var(--is-text)" stroke="var(--is-surface)" strokeWidth="1.4" strokeLinejoin="round"></path></svg>
  </div>
);

const MobileGraphic = () => (
  <div className="is-gfx gfx--mobile" aria-hidden="true">
    <div className="gfx-phone gfx-phone--android">
      <div className="gfx-phone__screen">
        <span className="gfx-punch"></span>
        <div className="gfx-droid">
          <div className="gfx-droid__bar">Trips<i></i></div>
          <div className="gfx-droid__item gfx-droid__item--next">
            <span className="gfx-droid__tag">UPCOMING · NOV 14</span>
            <div>YYZ<span className="gfx-droid__line"></span>YVR</div>
          </div>
          <div className="gfx-droid__item">
            <span className="gfx-droid__tag">DEC 20</span>
            <div>YYZ<span className="gfx-droid__line"></span>YUL</div>
          </div>
          <div className="gfx-droid__item">
            <span className="gfx-droid__tag">PAST · SEP 02</span>
            <div>YVR<span className="gfx-droid__line"></span>YYZ</div>
          </div>
          <div className="gfx-droid__item">
            <span className="gfx-droid__tag">PAST · JUL 18</span>
            <div>YYZ<span className="gfx-droid__line"></span>YHZ</div>
          </div>
          <span className="gfx-fab">+</span>
        </div>
      </div>
    </div>
    <div className="gfx-phone gfx-phone--ios">
      <div className="gfx-phone__screen">
        <span className="gfx-island"></span>
        <div className="gfx-status"><span>9:41</span><span className="gfx-status__icons"><i></i><i></i><i></i><b></b></span></div>
        <div className="gfx-notif">
          <span className="gfx-notif__icon"><svg viewBox="0 0 50 40"><circle cx="6" cy="6" r="4.5" fill="var(--is-accent)"></circle><path d="M6 13 V24 C6 33 13 37 19 33 C25 29 27 19 34 17 C41 15 46 21 46 27 C46 34 39 37 33 34 C28 31 25 25 20 23" fill="none" stroke="var(--is-on-primary)" strokeWidth="5" strokeLinecap="round"></path></svg></span>
          <span><b>Check-in is open</b><span>Seat 14A is held for you.</span></span>
        </div>
        <div className="gfx-trip">
          <div className="gfx-trip__head"><span className="gfx-trip__title">Your trip</span><span className="gfx-trip__ref">TR-2841</span></div>
          <div className="gfx-ticket">
            <div className="gfx-ticket__codes"><div>YYZ<small>Toronto</small></div><div>YVR<small>Vancouver</small></div></div>
            <div className="gfx-route"><i></i><b><svg viewBox="0 0 16 16"><path d="M1.5 9.2 L6 8.4 L9.6 2 H11.4 L9.7 8 L13.4 7.4 L14.6 5.6 H15.6 L15 8.6 L15.6 11.4 H14.6 L13.4 9.8 L9.7 9.4 L11.4 15.2 H9.6 L6 9.8 L1.5 9.2 Z" fill="currentColor"></path></svg></b><i></i></div>
            <div className="gfx-ticket__times"><span>08:15</span><span>4h 27m</span><span>10:42</span></div>
          </div>
          <div className="gfx-trip__grid">
            <span><small>Date</small><b>Nov 14</b></span>
            <span><small>Seat</small><b>14A</b></span>
            <span><small>Gate</small><b>C32</b></span>
          </div>
          <div className="gfx-trip__btn">Check in</div>
          <div className="gfx-tabbar"><i></i><i></i><i></i><i></i></div>
        </div>
        <span className="gfx-home-ind"></span>
      </div>
    </div>
  </div>
);

const CloudGraphic = () => (
  <div className="is-gfx gfx--cloud" aria-hidden="true">
    <div className="gfx-win gfx-win--dark">
      <div className="gfx-bar">
        <div className="gfx-lights"><i></i><i></i><i></i></div>
        <span className="gfx-title">pipelines / yourbrand-app / #482</span>
      </div>
      <div className="gfx-pipe">
        <div className="gfx-pipe__head"><span><b>Deploy to production</b> · main</span><span className="gfx-pipe__state">running</span></div>
        <div className="gfx-track"><span className="gfx-track__fill"></span></div>
        <div className="gfx-stations">
          <div className="gfx-station"><span className="gfx-station__dot"><svg viewBox="0 0 16 16"><path d="M3.5 8.5 L6.5 11.5 L12.5 4.5" fill="none" stroke="currentColor" strokeWidth="2.6" strokeLinecap="round" strokeLinejoin="round"></path></svg></span><b>Build</b><small>1m 12s</small></div>
          <div className="gfx-station"><span className="gfx-station__dot"><svg viewBox="0 0 16 16"><path d="M3.5 8.5 L6.5 11.5 L12.5 4.5" fill="none" stroke="currentColor" strokeWidth="2.6" strokeLinecap="round" strokeLinejoin="round"></path></svg></span><b>Test</b><small>2m 40s</small></div>
          <div className="gfx-station"><span className="gfx-station__dot"><svg viewBox="0 0 16 16"><path d="M3.5 8.5 L6.5 11.5 L12.5 4.5" fill="none" stroke="currentColor" strokeWidth="2.6" strokeLinecap="round" strokeLinejoin="round"></path></svg></span><b>Deploy</b><small>48s</small></div>
          <div className="gfx-station"><span className="gfx-station__dot"><svg viewBox="0 0 16 16"><path d="M3.5 8.5 L6.5 11.5 L12.5 4.5" fill="none" stroke="currentColor" strokeWidth="2.6" strokeLinecap="round" strokeLinejoin="round"></path></svg></span><b>Live</b><small>prod</small></div>
        </div>
      </div>
      <div className="gfx-log">
        <p><time>12:04:01</time>$ npm ci &amp;&amp; npm run build</p>
        <p><time>12:05:13</time><span className="ok">✓</span> build complete · 2.1 MB</p>
        <p><time>12:05:14</time>$ npm test -- --ci</p>
        <p><time>12:07:54</time><span className="ok">✓</span> all tests passed</p>
        <p><time>12:07:55</time>$ docker push registry/app:a3f9c1e</p>
        <p><time>12:08:31</time>rolling out to production · 3/3 ready</p>
        <p><time>12:08:43</time><span className="ok">✓ live</span> at app.yourbrand.ca <span className="gfx-log__caret"></span></p>
      </div>
    </div>
    <div className="gfx-chip gfx-commit">
      <span className="gfx-commit__icon"><i></i></span>
      <span><b>feat(checkout): add Apple Pay</b><small>a3f9c1e · main · just now</small></span>
    </div>
  </div>
);

const UxUiGraphic = () => (
  <div className="is-gfx gfx--uxui" aria-hidden="true">
    <div className="gfx-win">
      <div className="gfx-bar">
        <div className="gfx-lights"><i></i><i></i><i></i></div>
        <div className="gfx-tool"><i></i><i></i><i></i><i></i></div>
        <span className="gfx-title">Checkout flow</span>
        <div className="gfx-avatars"><i>AK</i><i>JM</i></div>
        <span className="gfx-share">Share</span>
      </div>
      <div className="gfx-design">
        <div className="gfx-layers">
          <h6>LAYERS</h6>
          <p>Home</p>
          <p>Cart</p>
          <p className="on">Checkout</p>
          <p className="sub">Header</p>
          <p className="sub">Order summary</p>
          <p className="sub">Pay button</p>
          <p>Confirmation</p>
        </div>
        <div className="gfx-board">
          <div className="gfx-art gfx-art--wire">
            <span className="gfx-art__label">Wireframe</span>
            <i style={{ width: "60%" }}></i>
            <i className="blk"></i>
            <i></i><i style={{ width: "70%" }}></i>
            <i className="blk"></i>
            <i></i><i style={{ width: "50%" }}></i>
            <i className="btn"></i>
          </div>
          <svg className="gfx-link" viewBox="0 0 80 60"><path d="M2 10 C40 10 40 50 76 50" fill="none" stroke="var(--is-accent)" strokeWidth="2" strokeLinecap="round"></path><circle cx="2" cy="10" r="3.5" fill="var(--is-accent)"></circle><circle cx="76" cy="50" r="3.5" fill="var(--is-surface)" stroke="var(--is-accent)" strokeWidth="2"></circle></svg>
          <div className="gfx-art gfx-art--ui">
            <span className="gfx-art__label">Checkout · v3</span>
            <span className="gfx-ui__title">Checkout</span>
            <div className="gfx-ui__item"><i></i><span><b>Everyday Tote</b><span>Navy · 1</span></span><em>$48</em></div>
            <div className="gfx-ui__item"><i></i><span><b>Card Wallet</b><span>Coral · 1</span></span><em>$28</em></div>
            <div className="gfx-ui__total"><span>Total</span><span>$76.00</span></div>
            <div className="gfx-ui__pay">Pay $76.00<span className="gfx-handle"></span><span className="gfx-handle"></span><span className="gfx-handle"></span><span className="gfx-handle"></span></div>
          </div>
          <div className="gfx-comment">
            <span className="gfx-comment__pin">AK</span>
            <span className="gfx-comment__body"><b>Bigger tap target on Pay?</b><span>Done — 48px ✓</span></span>
          </div>
        </div>
      </div>
    </div>
    <div className="gfx-cursor"><svg viewBox="0 0 18 22"><path d="M2 1 L2 18 L6.5 13.8 L9.6 20.5 L12.4 19.2 L9.4 12.6 L15.5 12.4 Z" fill="var(--is-accent)" stroke="var(--is-surface)" strokeWidth="1.4" strokeLinejoin="round"></path></svg><span className="gfx-cursor__name">Design team</span></div>
  </div>
);

const QaGraphic = () => (
  <div className="is-gfx gfx--qa" aria-hidden="true">
    <div className="gfx-win">
      <div className="gfx-bar">
        <div className="gfx-lights"><i></i><i></i><i></i></div>
        <span className="gfx-title">tests / checkout.spec.ts</span>
      </div>
      <div className="gfx-tests">
        <div className="gfx-tests__sum"><b>Checkout</b><span>5 passed</span><span>1 caught</span></div>
        <ol>
          <li className="gfx-test"><span className="gfx-check gfx-check--navy"><svg viewBox="0 0 16 16"><path d="M3.5 8.5 L6.5 11.5 L12.5 4.5" fill="none" stroke="currentColor" strokeWidth="2.6" strokeLinecap="round" strokeLinejoin="round"></path></svg></span>adds item to cart<time>112ms</time></li>
          <li className="gfx-test"><span className="gfx-check gfx-check--navy"><svg viewBox="0 0 16 16"><path d="M3.5 8.5 L6.5 11.5 L12.5 4.5" fill="none" stroke="currentColor" strokeWidth="2.6" strokeLinecap="round" strokeLinejoin="round"></path></svg></span>applies promo code<time>86ms</time></li>
          <li className="gfx-test"><span className="gfx-check gfx-check--navy"><svg viewBox="0 0 16 16"><path d="M3.5 8.5 L6.5 11.5 L12.5 4.5" fill="none" stroke="currentColor" strokeWidth="2.6" strokeLinecap="round" strokeLinejoin="round"></path></svg></span>validates postal code<time>41ms</time></li>
          <li className="gfx-test"><span className="gfx-check gfx-check--navy"><svg viewBox="0 0 16 16"><path d="M3.5 8.5 L6.5 11.5 L12.5 4.5" fill="none" stroke="currentColor" strokeWidth="2.6" strokeLinecap="round" strokeLinejoin="round"></path></svg></span>calculates HST for Ontario<time>23ms</time></li>
          <li className="gfx-test gfx-test--fail"><span className="gfx-x"><svg viewBox="0 0 16 16"><path d="M4.5 4.5 L11.5 11.5 M11.5 4.5 L4.5 11.5" fill="none" stroke="currentColor" strokeWidth="2.6" strokeLinecap="round"></path></svg></span>rejects an expired card<time>204ms</time><span className="gfx-test__err">expect(status).toBe(402)<br />received: 200</span></li>
          <li className="gfx-test"><span className="gfx-check gfx-check--navy"><svg viewBox="0 0 16 16"><path d="M3.5 8.5 L6.5 11.5 L12.5 4.5" fill="none" stroke="currentColor" strokeWidth="2.6" strokeLinecap="round" strokeLinejoin="round"></path></svg></span>sends order confirmation<time>310ms</time></li>
        </ol>
      </div>
    </div>
    <div className="gfx-chip gfx-api">
      <div className="gfx-api__req"><b>POST</b>/api/orders</div>
      <div className="gfx-api__res"><strong>201 Created</strong><br />{"{"} "id": "ord_8f2k",<br />&#160;&#160;"status": "paid" {"}"}</div>
    </div>
    <div className="gfx-chip gfx-ticket-card">
      <div className="gfx-ticket-card__top"><span>BUG · QA-142</span><span>Checkout</span></div>
      <b>Expired card accepted at checkout</b>
      <div className="gfx-ticket-card__meta"><span>High</span><span>In progress</span><i></i></div>
    </div>
  </div>
);

const MarketingGraphic = () => (
  <div className="is-gfx gfx--marketing" aria-hidden="true">
    <div className="gfx-win">
      <div className="gfx-bar">
        <div className="gfx-lights"><i></i><i></i><i></i></div>
        <span className="gfx-title">campaigns / spring-launch</span>
      </div>
      <div className="gfx-dash">
        <div className="gfx-dash__head"><b>Spring launch</b><span className="gfx-dash__tag">EXAMPLE DATA</span>
          <div className="gfx-seg"><span>All</span><span>Paid</span><span>Email</span><span>Social</span></div>
        </div>
        <div className="gfx-kpis">
          <div className="gfx-kpi"><small>Visits</small><b>12.4k</b><em>↑</em></div>
          <div className="gfx-kpi"><small>Sign-ups</small><b>860</b><em>↑</em></div>
          <div className="gfx-kpi"><small>Cost per sign-up</small><b>$4.20</b><em>↓</em></div>
        </div>
        <div className="gfx-chart">
          <div className="gfx-chart__plot">
          <svg viewBox="0 0 480 120" preserveAspectRatio="none">
            <line x1="0" y1="30" x2="480" y2="30" stroke="var(--is-border-subtle)" strokeDasharray="2 4"></line>
            <line x1="0" y1="70" x2="480" y2="70" stroke="var(--is-border-subtle)" strokeDasharray="2 4"></line>
            <line x1="0" y1="110" x2="480" y2="110" stroke="var(--is-border)"></line>
            <path d="M0 96 C40 92 60 86 80 88 S140 80 160 78 S220 84 240 74 S300 70 320 66 S380 70 400 60 S450 56 470 54" fill="none" stroke="var(--is-border-dotted)" strokeWidth="2" strokeDasharray="4 5"></path>
            <path d="M0 100 C40 96 60 90 80 86 S140 70 160 72 S220 60 240 56 S300 50 320 42 S380 40 400 32 S450 22 470 18 L470 110 L0 110 Z" fill="var(--is-bg)"></path>
            <path className="gfx-chart__line" d="M0 100 C40 96 60 90 80 86 S140 70 160 72 S220 60 240 56 S300 50 320 42 S380 40 400 32 S450 22 470 18" fill="none" stroke="var(--is-primary)" strokeWidth="3.5" strokeLinecap="round" vectorEffect="non-scaling-stroke"></path>
          </svg>
          <span className="gfx-chart__end"></span>
          <span className="gfx-chart__tip"><b>2,140 visits</b>Sunday</span>
          </div>
          <div className="gfx-chart__days"><span>MON</span><span>TUE</span><span>WED</span><span>THU</span><span>FRI</span><span>SAT</span><span>SUN</span></div>
        </div>
        <div className="gfx-split">
          <div className="gfx-split__bar"><i></i><i></i><i></i></div>
          <div className="gfx-split__legend"><span>Paid</span><span>Email</span><span>Social</span></div>
        </div>
      </div>
    </div>
    <div className="gfx-chip gfx-live">
      <span className="gfx-live__dot"></span>
      <span><b>Ad set is live</b><span>Spring · Kitchener-Waterloo</span></span>
    </div>
  </div>
);

const SupportGraphic = () => (
  <div className="is-gfx gfx--support" aria-hidden="true">
    <div className="gfx-win">
      <div className="gfx-bar">
        <div className="gfx-lights"><i></i><i></i><i></i></div>
        <div className="gfx-url"><svg viewBox="0 0 8 9"><rect x="0.5" y="4" width="7" height="4.5" rx="1" fill="currentColor"></rect><path d="M2 4 V2.6 a2 2 0 0 1 4 0 V4" fill="none" stroke="currentColor" strokeWidth="1.1"></path></svg>status.yourbrand.ca</div>
      </div>
      <div className="gfx-statuspage">
        <div className="gfx-statuspage__ok">
          <span className="gfx-check gfx-check--navy"><svg viewBox="0 0 16 16"><path d="M3.5 8.5 L6.5 11.5 L12.5 4.5" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round"></path></svg></span>
          <span><b>All systems operational</b><span>Checked 1 min ago</span></span>
        </div>
        <div className="gfx-comp"><div>Website<span>operational</span></div><Uptime /></div>
        <div className="gfx-comp"><div>API<span>operational</span></div><Uptime /></div>
        <div className="gfx-comp"><div>Payments<span>operational</span></div><Uptime hit={18} /></div>
        <div className="gfx-comp"><div>Mobile app<span>operational</span></div><Uptime /><div className="gfx-uptime__axis"><span>30 days ago</span><span>today</span></div></div>
      </div>
    </div>
    <div className="gfx-chip gfx-releases">
      <h6>Releases<span>yourbrand-app</span></h6>
      <ol>
        <li><b>v2.4.1</b><time>Today</time><span>Fixed rounding at checkout</span></li>
        <li><b>v2.4.0</b><time>Oct 14</time><span>Faster product search</span></li>
        <li><b>v2.3.2</b><time>Oct 02</time><span>Security patches</span></li>
        <li><b>v2.3.1</b><time>Sep 25</time><span>iOS layout fixes</span></li>
      </ol>
    </div>
  </div>
);

const GRAPHICS: Record<string, ComponentType> = {
  web: WebGraphic,
  mobile: MobileGraphic,
  cloud: CloudGraphic,
  uxui: UxUiGraphic,
  qa: QaGraphic,
  marketing: MarketingGraphic,
  support: SupportGraphic,
};

/** Graphic for a service id from src/content/services.ts (null if none). */
const ServiceGraphic = ({ id }: { id: string }) => {
  const Graphic = GRAPHICS[id];
  return Graphic ? <Graphic /> : null;
};

export default ServiceGraphic;
